import { registerSchema } from './RegisterValidationSchema';
import { getLaravelValidationErrors } from '../../../helpers';
import { SETTINGS_FINANCIAL,LOGIN ,ROOT} from '../../../constants/routes';
import { registerUser } from '../../../reducers/auth/auth.actions';

const formik = ({ history, dispatch, location }) => {
  return {
    initialValues: {
      name: '',
      email: '',
      password: '',
      password_confirmation: '',
    },
    validationSchema: registerSchema,
    onSubmit: (values, { setSubmitting, setStatus }) => {
      dispatch(registerUser(values))
        .then(response => {
          // alert("We have sent you an e-mail to activate your account. Please activate your account to log in")
          
          setTimeout(() => {
            history.push({
              pathname: ROOT,
      
            });
           
          }, 2000);
        })
        .catch(errors => {
          setStatus({
            errors: getLaravelValidationErrors(errors),
          });
          setSubmitting(false);
        });
    },
  };
};

export default formik;
